import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PricePlanBundleRequestsService} from "../../services/price-plan-bundle-requests.service";


export class PricePlanBundleTreeViewComponent implements IController {
  parentPlan = undefined;
  bundles = [];
  loading: boolean = false;

  constructor(private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private $stateParams, private $state, private $log) {
  }

  $onInit() {
    this.loadList(this.$stateParams.selectedPlan);
  }

  // Load Children bundles of pricePlan Bundle [id]
  loadChildren(id) {
    this.bundles = [];
    this.loading = true;
    this.pricePlanBundleRequestsService.getAllChilds(id)
      .then((res) => {
        this.bundles = this.sortList(res);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get all children bundles @pricePlanBundleTreeView@loadChildren', error)
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  // Load root level pricePlan Bundles
  loadRootBundles() {
    this.bundles = [];
    this.loading = true;
    this.pricePlanBundleRequestsService.getRootBundles()
      .then((rootBundles) => {
        this.bundles = this.sortList(rootBundles);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get all root bundles @pricePlanBundleTreeView@loadAllBundles', error)
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  // Use URL params to select price plan and pass new crumbs to keep track of where the user was before
  onSelect(bundle) {
    let newCrumbIds = this.$stateParams.crumbIds ? this.$stateParams.crumbIds : [];
    let newCrumbName = this.$stateParams.crumbNames ? this.$stateParams.crumbNames : [];
    newCrumbIds = Array.isArray(newCrumbIds) ? newCrumbIds : [newCrumbIds];
    newCrumbIds.push(bundle.id);
    newCrumbName = Array.isArray(newCrumbName) ? newCrumbName : [newCrumbName];
    newCrumbName.push(bundle.name);
    this.$state.go('pricePlans', {selectedPlan: bundle.id, crumbIds: newCrumbIds, crumbNames: newCrumbName});
  }

  refreshList() {
    this.loadList(this.$stateParams.selectedPlan);
  }

  // ******************************
  //        Private methods
  // ******************************

  // Sort list according to default first and than by name.
  private sortList(list) {
    list = _.orderBy(list, [
      function (elem) {
        return elem.isDefault;
      },
      function (elem) {
        return elem.name ? elem.name.toLowerCase() : '';
      }
    ], ['desc', 'asc']);
    return list;
  }

  // Either load ROOT level or the selected PricePlan Bundle and it's children
  private loadList(selectedPlanId) {
    if (selectedPlanId) {
      this.parentPlan = undefined;
      this.pricePlanBundleRequestsService.getBundleById(selectedPlanId)
        .then((bundle) => {
          this.parentPlan = bundle;
        })
        .catch((error) => {
          if (error) {
            this.$log.error('Failed to get all root bundles @pricePlanBundleTreeView@loadList', error)
          }
        })
        .finally(() => {
          this.loading = false;
        });
      this.loadChildren(selectedPlanId);
    } else {
      this.loadRootBundles();
    }
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundleTreeView', {
    bindings: {},
    template: require('./price-plan-bundle-tree-view.html').default,
    controller: PricePlanBundleTreeViewComponent
  });
